<!-- Tableau -->
<div class="container-fluid">
  <div class="text-end mt-3" *appProfilePerimeter>
    <button
      type="button"
      class="btn btn-primary"
      *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
      (click)="openCreateModal()"
      [disabled]="!canAnswerSurvey"
    >
      Ajouter un questionnaire
    </button>
  </div>
  <div class="row mt-2">
    <div class="col px-0">
      <table class="table table-striped table-hover" aria-describedby="fseTitle">
        <thead class="text-secondary bg-light">
          <tr>
            <th></th>
            <th scope="col" class="text-center" sortable="actionId" (sort)="onSort($event)">Libellé</th>
            <th scope="col" class="text-center" sortable="beginDate" (sort)="onSort($event)">Date Entrée</th>
            <th scope="col" class="text-center" sortable="endDate" (sort)="onSort($event)">Date Sortie</th>
            <th scope="col" class="text-center" sortable="directedBy" (sort)="onSort($event)">Créé par</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let surveyFSE of surveysFSE.items" (click)="openConsultModal(surveyFSE.id)">
            <td></td>

            <td class="text-center" *ngIf="surveyFSE.surveyContextId">{{ labelsBySurveyContext.get(surveyFSE.surveyContextId) }}</td>
            <td class="text-center" *ngIf="!surveyFSE.surveyContextId">{{ surveyFSE.action }}</td>

            <td class="text-center">{{ surveyFSE.beginDate | date }}</td>
            <td class="text-center">{{ surveyFSE.endDate | date }}</td>
            <td class="text-center">{{ surveyFSE.directedBy }}</td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="surveysFSE.items.length === 0">Le bénéficiaire n'a aucun questionnaire.</p>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <ngb-pagination
      [collectionSize]="surveysFSE.totalItems"
      [page]="surveysFSE.options.page"
      [pageSize]="surveysFSE.options.limit"
      (pageChange)="changePage($event)"
    >
    </ngb-pagination>
    <select class="w-auto form-select" [ngModel]="surveysFSE.options.limit" (change)="changeLimit($event)">
      <option [value]="10">10 éléments par page</option>
      <option [value]="25">25 éléments par page</option>
      <option [value]="50">50 éléments par page</option>
      <option [value]="100">100 éléments par page</option>
    </select>
  </div>
</div>
